import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import { PU_TARGET } from '../../../../../Widgets/DataPainterWidget/PowerUsageWidget/powerUsageConst';
import commandEngine from './CommandEngine';
import { CMD_POWERUSAGE_REGISTRY_KEY, META_TYPE, META_VER } from './powerUsageCommandRegisteryType';

/**
 * Registers the /power command with the CommandEngine.
 * /power — opens/refocuses the power usage summary card (single instance, target=power).
 */
export function registerPowerUsageCommand() {
    commandEngine.register('/power', {
        hint: 'open power usage card (import, export, costs)',
        params: [],
        handler: () => {
            cardPainterManager.openCard(CMD_POWERUSAGE_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: PU_TARGET }, { rk: PU_TARGET });
        },
    });
}
